module.exports = __webpack_public_path__ + "img/aidex_x_logo.30ee6adc.svg";